module.exports = __webpack_public_path__ + "resources/icon_28_write_blue.460831c8dc82e999.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_28_write_blue.png
// module id = 472
// module chunks = 0 1 2 3 4